import { Gesture } from "./BaseGesture"

export default function () {
  const { stopEditing } = useProperty()
  const { selectFile } = useSelection()
  const { state: gestureState, isOverPath, isPrimaryClick, getPathFileFromEvent, gestureLayers } = useGestures()
  class PathFileDragToMove extends Gesture {
    override layer = gestureLayers.navigation
    #isPreDrag = false
    #draggedFile: InterfaceFile | undefined

    override reset() {
      this.#isPreDrag = false
      this.#draggedFile = undefined
      this.switchMode("none")
    }

    // Dragging to move means we want to
    override async onMouseDown(mouse: MouseEvent) {
      if (!isPrimaryClick(mouse) || !isOverPath(mouse))
        return

      // With path files, we don't want to "select" the file when clicked, but we do want
      // to auto-select it when a move starts, so just set up our state here.

      this.#isPreDrag = true
      this.#draggedFile = getPathFileFromEvent(mouse)
    }

    override async onMouseMove(
      mouse: MouseEvent,
    ) {
      // do not set the dragged file to undefined, as we want that to remain
      // in state during the drag, but the pre drag only needs to execute once
      if (!this.#isPreDrag || !isDefined(this.#draggedFile))
        return

      this.console.debug("Dragging path file", this.#draggedFile)

      // check displacement from mouse down to tell if we have become a full drag or not
      const xDist = gestureState.value.mouseDown!.clientX - mouse.clientX
      const yDist = gestureState.value.mouseDown!.clientY - mouse.clientY
      const dist = Math.sqrt(xDist ** 2 + yDist ** 2)
      if (dist < 3)
        return

      // we need to capture this mouse move as the drag is occurring
      this.capture()
      stopEditing()
      this.#isPreDrag = false
      selectFile(this.#draggedFile, "nav")
      this.switchMode("drag-file")
    }

    override async onMouseUp(
      _mouse: MouseEvent,
    ) {
      if (this.#draggedFile)
        this.reset()
    }
  }
  return new PathFileDragToMove()
}
